import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { OfferStoreContext } from "@gp/components";

import { LiveStatus } from "@gp/models";

import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { TSection } from "@data-types/offer/live/Section";

export const RemoveAllFavoritesButton = observer(
	function RemoveAllFavoritesButton() {
		const favoritesStore = useContext(FavoritesStoreContext);
		const offerStore = useContext(OfferStoreContext);
		const { t } = useTranslation();

		//@ts-expect-error
		const { period, activeFavoriteTournamentIds } = offerStore;

		const isEvents =
			period == TSection.MyFavoritesEvents &&
			favoritesStore.liveFavoritesCounter > 0;
		const isTournaments =
			period == TSection.MyFavoritesTournaments &&
			activeFavoriteTournamentIds.length > 0;

		if (!isEvents && !isTournaments) {
			return null;
		}
		return (
			<div className="pagination">
				<div className="pagination__remove">
					<button
						className="pagination__remove__btn btn btn--sml btn--ghost--danger"
						type="button"
						onClick={() =>
							isEvents
								? favoritesStore.deselectFavoritesEvents(
										LiveStatus.LIVE
								  )
								: favoritesStore.deselectFavoriteTournamentsLive(
										activeFavoriteTournamentIds
								  )
						}
					>
						{t("FAVORITES.REMOVE_ALL_FAVORITES")}
					</button>
				</div>
			</div>
		);
	}
);
